<template>
  <d-card class="card-small h-100">
    <!-- Card Header -->
    <d-card-header class="border-bottom">
      <h6 class="m-0">{{ title }}</h6>
      <div class="block-handle"></div>
    </d-card-header>

    <d-card-body class="pt-0">
      <!-- Legend & Chart -->
      <div ref="legend"></div>
      <canvas
        height="120"
        ref="canvas"
        style="max-width: 100% !important;"
      ></canvas>
    </d-card-body>
  </d-card>
</template>

<script>
import Chart from "../../utils/chart";

const defaultChartData = {
  labels: Array.from(new Array(12), (_, i) => (i === 0 ? 1 : i + 1)),
  datasets: [
    {
      label: "Monthly Donors",
      fill: "start",
      data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 200],
      backgroundColor: "#f3fbf685",
      borderColor: "#60c592",
      pointBackgroundColor: "#ffffff",
      pointHoverBackgroundColor: "#f3fbf685",
      borderWidth: 1,
      pointRadius: 0,
      pointHoverRadius: 2,
      pointBorderColor: "#60c592"
    },

    {
      label: "New supporters",
      fill: "start",
      data: [380, 430, 430, 430, 430, 440, 490, 429, 561, 579, 580, 593],
      backgroundColor: "#f1f9fbad",
      borderColor: "#70d0e2",
      pointBackgroundColor: "#ffffff",
      pointHoverBackgroundColor: "#f1f9fbad",
      borderWidth: 1,
      pointRadius: 0,
      pointHoverRadius: 2,
      pointBorderColor: "#70d0e2"
    },

    {
      label: "Actions",
      fill: "start",
      data: [500, 800, 320, 180, 240, 320, 230, 650, 590, 1200, 750, 940],
      backgroundColor: "#fcf9f38c",
      borderColor: "#fed98d",
      pointBackgroundColor: "#ffffff",
      pointHoverBackgroundColor: "#fcf9f38c",
      borderWidth: 1.5,
      pointRadius: 0,
      pointHoverRadius: 3,
      pointBorderColor: "#fed98d"
    }
  ]
};

export default {
  name: "users-overview",
  props: {
    title: {
      type: String,
      default: "supporters Overview"
    },
    chartData: {
      type: Object,
      default() {
        return defaultChartData;
      }
    }
  },
  data() {
    return {
      dateRange: {
        from: null,
        to: null
      }
    };
  },
  mounted() {
    const chartOptions = {
      ...{
        responsive: true,
        legend: {
          position: "top"
        },
        elements: {
          line: {
            // A higher value makes the line look skewed at this ratio.
            tension: 0.3
          },
          point: {
            radius: 0
          }
        },
        scales: {
          xAxes: [
            {
              gridLines: false,
              ticks: {
                callback(tick, index) {
                  // Jump every 7 values on the X axis labels to avoid clutter.
                  //return index % 7 !== 0 ? "" : tick;
                  return tick;
                }
              }
            }
          ],
          yAxes: [
            {
              ticks: {
                suggestedMax: 45,
                callback(tick) {
                  if (tick === 0) {
                    return tick;
                  }
                  // Format the amounts using Ks for thousands.
                  return tick > 999 ? `${(tick / 1000).toFixed(1)}K` : tick;
                }
              }
            }
          ]
        },
        hover: {
          mode: "nearest",
          intersect: false
        },
        tooltips: {
          custom: false,
          mode: "nearest",
          intersect: false
        }
      },
      ...this.chartOptions
    };

    const BlogUsersOverview = new Chart(this.$refs.canvas, {
      type: "LineWithLine",
      data: this.chartData,
      options: chartOptions
    });

    // They can still be triggered on hover.
    const buoMeta = BlogUsersOverview.getDatasetMeta(0);
    buoMeta.data[0]._model.radius = 0;
    buoMeta.data[this.chartData.datasets[0].data.length - 1]._model.radius = 0;

    // Render the chart.
    BlogUsersOverview.render();
  }
};
</script>
